import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment } from "semantic-ui-react";
import axios from 'axios';

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";

import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../src/css/convenios.css";
import { MySelectInputControl } from "../../../app/common/form/MySelectInput";
import ListEstudiantesXConvenio from "../../PerfilInstitucional/handlers/ListEstudiantesXConvenio";

export default observer(function ModalMatricularMasiva(
    CO: {
        show: any,
        onHide: any,
        conv: string,
        convref: string,
    }) {

    return (

        <>

            <Modal
                {...CO}
                size="xl"
                className="modal-add-dep-content"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Header closeButton >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Matriculación masiva.
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Container className="modal-sol-detalle form-area">

                        Formulario para matricular

                    </Container>

                </Modal.Body>

            </Modal>

        </>

    );

})